"use strict"

const is_safari = /apple/i.test(navigator.vendor)&&/apple|webkit|safari/i.test(navigator.userAgent);

import {Renderer} from './renderer.js';
import {Dialog} from './dialog.js';
import {Grid} from './grid.js';

const INPUT_SELECTOR=/*'select:not([readonly]):not([disabled]):not(.disabled),'
                    +'input:not([type=hidden]):not([readonly]):not([disabled]):not(.disabled),' 
                    +'textarea:not([readonly]):not([disabled]):not(.disabled),'
                    +'button:not([readonly]):not([disabled]):not(.disabled)'
                   // +'a[href]:not([readonly]):not([disabled]):not(.disabled)';*/
    'select:not([disabled]):not(.disabled),'
    +'input:not([type=hidden]):not([disabled]):not(.disabled),'
    +'textarea:not([disabled]):not(.disabled),'
    +'button:not([disabled]):not(.disabled)'; // zkusíme to bez readonly, normálně se readonly taky tabují...

const INPUT_SELECTOR_GRID='select:not([disabled]):not(.disabled),' 
                    +'input:not([type=hidden]):not([disabled]):not(.disabled),' 
                    +'textarea:not([disabled]):not(.disabled),'
                    +'button:not([disabled]):not(.disabled)'
                   // +'a[href]:not([disabled]):not(.disabled)';

const DEFAULTS={
    
    closable:true,
    shiftable:false, 
    left:"auto", 
    top:"auto", 
    width:"auto", 
    height:"auto", 
    
}

const DIALOG_DEFAULTS={
    
    closable:false,
    shiftable:false, 
    left:"auto", 
    top:"auto", 
    width:"auto", 
    height:"auto", 
    
}

const GRID_DEFAULTS={
    
    closable:true,
    shiftable:false, 
    left:"auto", 
    top:"auto", 
    width:"auto", 
    height:"auto", 
    
}

const ALERT_DEFAULTS={
    
    closable:false,
    shiftable:false, 
    left:"auto", 
    top:"auto", 
    width:"auto", 
    height:"auto", 

}

let INSTANCES={};
let BOX_ORDER=[];

let ALERT_INSTANCE;
let ALERT_QUEUE=[];

let GRID_INSTANCE;

let ACTUAL_INSTANCE;


let KILL_TIMEOUT;

export class VutBox {
    
    static shown(){
        return (!!VutBox.container)&&(VutBox.container.parentNode===document.body)&&!VutBox.container.matches('.vutbox-fade-out')
    }

    static gridShown(){
        return GRID_INSTANCE.shown;
    }

    static gridFocused(){
        return GRID_INSTANCE.shown&&!ALERT_INSTANCE.shown&&GRID_INSTANCE.outer.matches('.focused');
    }

    static gridResize(){
        Renderer.resize(GRID_INSTANCE, false, false);
        return GRID_INSTANCE;
    }
    
    static init() {
        Renderer.init(VutBox);
        VutBox.Dialog=Dialog;
        VutBox.Grid=Grid;

        if (is_safari) {
            setInterval(VutBox.safariObserver, 1500);
        } else {
            try {
                VutBox.Observer = new ResizeObserver(VutBox.observer);
            } catch (e) {
                console.error(e);
            }
        }

        (VutBox.container=document.createElement('div')).setAttribute('id', 'vutbox-container');
        VutBox.container.addEventListener('click', VutBox.click, true);
        VutBox.container.addEventListener('scroll', VutBox.scroll, true);
        
        window.addEventListener('keydown', VutBox.keydown, true);

        (ALERT_INSTANCE=new VutBox(ALERT_DEFAULTS)).setOnClose(VutBox.alertShift);
        (GRID_INSTANCE=new VutBox(GRID_DEFAULTS));

        ACTUAL_INSTANCE=VutBox.box('VutBox');
        
    }

    static isAlert(box) {return box===ALERT_INSTANCE}
    static isGrid(box) {return box===GRID_INSTANCE}

    static addDefaults(cfg, defaults=DEFAULTS) {
        Object.keys(defaults).forEach((key)=>{
            if (typeof cfg[key] === 'undefined') {
                cfg[key]=defaults[key];
            }
        });
        
        return cfg;
    }
        
    static show(content) {

        return VutBox.box('VutBox').setCfg(DEFAULTS).setContent(typeof content === 'undefined' ? '':content).show();
        
    }

    static alert(head='', prompt='') {

        let alert={
            head:(head!=='')&&(prompt!=='')?head:'',
            prompt:prompt===''?head:prompt,
            buttons:[{name:'OK', class:'btn-primary', callback:()=>{ALERT_INSTANCE.hide()}}],
        }

        ALERT_QUEUE.push(alert);
        if (!ALERT_INSTANCE.shown) {
            VutBox.alertShift();
        }
        
    }

    static grid(gridCfg) {

        if (GRID_INSTANCE.shown) return;

        try {
            let grid=new Grid(gridCfg)
            let box=GRID_INSTANCE.show(grid);
            box.outer.setAttribute('id', 'vutbox-grid');
            grid.grid.render();
            box.resize();
        } catch(e) {
            console.error(e);
        }

    }

    static alertShift() {
        let alert=ALERT_QUEUE.shift();
        if (alert) {
            ALERT_INSTANCE.show(new Dialog(alert)).outer.classList.add('alert');
            return false;
        }
    }
        
    static dialog(head='', prompt='', buttons) {
        let content;
        
        if (head&&(typeof head=="object")) {
            content=new Dialog({
                head:head.head,
                prompt:head.prompt,
                buttons:head.buttons,                
            });
        } else {
            content=new Dialog({
                head:head,
                prompt:prompt,
                buttons:buttons,
            });
        }

        return VutBox.box('VutBoxDialog').setCfg(DIALOG_DEFAULTS).setContent(content).show();
    }           
        

    static resize() {

        if (VutBox.shown()) {
            Object.keys(INSTANCES).forEach((key) => Renderer.resize(INSTANCES[key]));
            ALERT_INSTANCE.resize();
            GRID_INSTANCE.resize();
        }
    }
    
   /* static getWindowDimensions() {

        let overlay;

        if (!(overlay=VutBox.container.querySelector('.vutbox-overlay'))) {
            VutBox.container.insertAdjacentHTML('afterBegin', '<div class="vutbox-overlay"></div>')
            overlay=VutBox.container.querySelector('.vutbox-overlay');
        }

        VutBox.window=VutBox.window||{
            width:overlay.clientWidth,
            height:overlay.clientHeight,
        }

    }

    static clearWindowDimensions() {
        VutBox.window=null;
    }*/
    
    static hide(id) {
                
        clearTimeout(KILL_TIMEOUT);
        let box=id instanceof VutBox?id:(INSTANCES[id]||ACTUAL_INSTANCE);

        if (box instanceof VutBox) {
            if (VutBox.container) {

                try {
                    let ee=new CustomEvent('VutBoxClose', {cancelable:true});
                    ee.boxId=id;
                    document.body.dispatchEvent(ee);
                    if (ee.defaultPrevented) return;
                } catch(e) {}

                try {

                    if (typeof box.cfg.onclose === 'function') { if (box.cfg.onclose(box)===false) return; }
                    else if (typeof box.cfg.onclose === 'string') {
                        let fn=(context, fnName)=>{ // rekurzivní nalezení zanořené funkce, např. window.console.log
                            if (typeof context[fnName]=='function') return context[fnName];
                            else if (typeof fnName=='string') {
                                let c=fnName.split('.')[0];
                                let f=fnName.split('.').reduce((t,v,i)=>t+=i?v:'', '');
                                if (context[c]&&f) return fn(context[c], f);
                            }
                        }
                        let r;
                        r=fn(window, box.cfg.onclose);
                        if (typeof r == 'function') {
                            if (r(action.fnData)===false) {return;}
                        } else {
                            console.error("VutBox onclose: neexistuje funkce ", action.fnName);
                        }                    
                    }

                } catch(e) {console.error('VutBox onclose: ', e);}

                box.alive=VutBox.isAlert(box)
                    ?ALERT_QUEUE.length
                    :false
                ;

                // není živá instance - zabiju kontainer
                if (!(Object.keys(INSTANCES).some((id)=>INSTANCES[id].shown)||ALERT_INSTANCE.shown||GRID_INSTANCE.shown)) {
                    VutBox.container.classList.remove('vutbox-fade-in');
                    KILL_TIMEOUT=setTimeout(()=>{
                        VutBox.container.classList.add('vutbox-fade-out');
                    }, 25);
                };

                box.outer.classList.remove('vutbox-fade-in');
                box.killTimeout=setTimeout(()=>{
                    box.outer.classList.add('vutbox-fade-out');
                }, 25);

            } 
            
        }
        
        return box;
        
    }
    
    static focus(box) {
        if (!(box&&box.shown)) return;
        GRID_INSTANCE.outer.classList[box===GRID_INSTANCE?'add':'remove']('focused');
        Object.keys(INSTANCES).forEach((key)=>{ 
            if (key==box.id) {ACTUAL_INSTANCE=INSTANCES[key];}
            INSTANCES[key].outer.classList[key==box.id?'add':'remove']('focused');
        });
    }

    static box(id) {
        return id
            ?(INSTANCES[id]=INSTANCES[id]||(new VutBox(VutBox.addDefaults({}), id)))
            :ACTUAL_INSTANCE
    }

    constructor(cfg, id) {
        
        this.cfg=cfg;
        Object.defineProperty(this, 'id', {value:id, writable:false})
        Object.defineProperty(this, 'outer', {value:document.createElement('div'), writable:false})
        Object.defineProperty(this, 'inner', {value:document.createElement('div'), writable:false})
        Object.defineProperty(this, 'closeButton', {value:document.createElement('div'), writable:false})

        if (VutBox.Observer) { VutBox.Observer.observe(this.inner); }
        
    }

////////    

    show(content) {

        clearTimeout(KILL_TIMEOUT);
        (BOX_ORDER=BOX_ORDER.filter((box)=>box!=this)).unshift(this);
        if (content) { this.content=content; }
        return Renderer.render(this);

    }

    open(content) {
        return this.show(content);
    }

    replace(content) {
        return this.show(content);
    }

////////
    
    hide() { 
        return VutBox.hide(this);
    }
    close() {
        return VutBox.hide(this);
    }
    
////////

    focus() {
        return VutBox.focus(this);
    }

////////    
    
    resize() {
        Renderer.resize(this);
        return this;
    }

////////    

    get shown() {
        return (!!this.alive)&&(this.outer.offsetParent===VutBox.container)&&(this.inner.offsetParent===this.outer);
    }

////////    
    
    get focused() {
        return (this.shown&&(this===ACTUAL_INSTANCE)&&!ALERT_INSTANCE.shown&&this.outer.matches('.focused'));
    }

////////    
    
    dialog(head='', prompt='', buttons) {
                
        if (head&&(typeof head == 'object')) {
            this.content=new Dialog({
                head:head.head,
                prompt:head.prompt,
                buttons:head.buttons,
            });
        } else {
            this.content=new Dialog({
                head:head,
                prompt:prompt,
                buttons:buttons,
            });            
        }
        
        return this.show();
    }
    
    setOnClose(fn) {
        this.cfg.onclose=fn;
        return this;
    }

    setOnclose(fn) {
        this.cfg.onclose=fn;
        return this;
    }
    
    setContent(content) {
        if (typeof content !== 'undefined') {
            this.content=content;
        }
        return this;
    }
    
    setClosable(closable) {
        this.cfg.closable=!!closable;
        if (closable) {
            this.outer.appendChild(this.closeButton);
            if (this.closeButton.offsetTop<0) {this.resize()}
        } else if (this.closeButton.parentNode) {
            if (this.closeButton.offsetTop<0) {this.closeButton.parentNode.removeChild(this.closeButton); this.resize();}
            else {this.closeButton.parentNode.removeChild(this.closeButton);}
        }            
        return this;
    }

////////    

    get reset(){
        this.cfg=VutBox.addDefaults({}, DIALOG_DEFAULTS);   
        return this;
    }

    get resetDialog(){
        this.cfg=VutBox.addDefaults({}, DEFAULTS);        
        return this;
    }

////////
    
    setCfg(cfg) {
        if (cfg&&(typeof cfg == 'object')) {
            Object.keys(cfg).forEach((key)=>{
                if (typeof DEFAULTS[key]!=='undefined') {
                    this.cfg[key]=cfg[key];
                }
            });
        }
        return this;
    }

    setConfig(cfg) {
        return this.setCfg(cfg);
    }
        
    static click(event) {

        let id, box;
        let outer=event.target;
        while (outer instanceof HTMLElement) {
            if (outer.matches('.vutbox-outer')) break;
            outer=outer.parentNode;
        }
        if ((outer instanceof HTMLElement)&&(id=Object.keys(INSTANCES).find((key)=>INSTANCES[key].outer===outer))&&(box=INSTANCES[id])) {
            if (event.target.matches('.vutbox-close, .vutbox-close *')) {return box.close(); }
        }
        
    }

    static safariObserver() {
        if (VutBox.shown()) {
            Object.values(INSTANCES).forEach(box=>Renderer.resize(box, true));
        }
    }

    static observer(entries) {

        if (VutBox.shown()) {
            entries.forEach((entry)=>{
                let id, box;
                if ((id=Object.keys(INSTANCES).find((key)=>INSTANCES[key].inner===entry.target))&&(box=INSTANCES[id])) {
                    Renderer.resize(box, true);
                }
            });
        }

    }
    
    
    static keydown(event) {
        if (
            (event.key?.toLowerCase()==='tab')
            &&VutBox.shown()
        ) {
            if (ALERT_INSTANCE.shown) {
                event.preventDefault();
                return false;                
            } else if (ACTUAL_INSTANCE.focused) {
                VutBox.__keytab(ACTUAL_INSTANCE, event.shiftKey);
                event.preventDefault();
                return false;
            } else if (VutBox.gridFocused()&&!GRID_INSTANCE.inner.querySelector('.datagrid2 .-grid .-body .-row .-cell.-active')) {
                VutBox.__keytab(GRID_INSTANCE, event.shiftKey);
                event.preventDefault();
                return false;
            }
        }
    }
    
    static __keytab(box, shift, first) {
            let l, input, focusable=[], actual=shift?0:-1;
            if (l=(input=box.inner.querySelectorAll(VutBox.isGrid(box)?INPUT_SELECTOR_GRID:INPUT_SELECTOR)).length) {

                for (let i=0; i<l; i++) {
                    if ((!first)&&(input[i]==document.activeElement)) {actual=focusable.length;}
                    if (input[i].offsetParent) {focusable.push(input[i]);}

                }
            }

            if (l=focusable.length) {
                setTimeout(()=>{focusable[(l+actual+(shift?-1:1))%l].focus();}, 25);
            }        
    }
    
    static scroll(event) {
        if (event.target.matches('.vutbox-inner')) {
            if (event.target.matches('--resizing')&&!(event.target.scrollTop&&event.target.scrollLeft)) return;
            event.target.dataset.scrollTop=event.target.scrollTop;
            event.target.dataset.scrollLeft=event.target.scrollLeft;
        }
    }
    
}


let transitionend = (event) => {
    let target;
    if (target = event.target?.closest?.('.vutbox-fade-out')) {
        target.innerHTML = '';
        target.remove();
        if (target.matches('.vutbox-outer')) {
            BOX_ORDER=BOX_ORDER.filter((v)=>target!==v.outer);
            VutBox.focus(BOX_ORDER[0]);
        } else if (target.matches('#vutbox-container')) {
            BOX_ORDER = [];
        }
    }
}

window.addEventListener('blur', (event)=>{
    let e;
    while ( e = document.querySelector('.vutbox-fade-out') ) {
        transitionend({target:e});
    }
}, false);


'transitionend,transitioncancel,animationend,animationcancel'.split(',').forEach(e=>window.addEventListener(e, transitionend, true));